function uniqueId() {
  return (Number(String(Math.random()).slice(2)) + Date.now()).toString(36)
}

export default uniqueId